import type { Space } from '@cocoonspace/sdk-js/types/space'
import { Users } from 'lucide-react'
import type { ComponentProps } from 'react'
import { cn } from '~/lib/utils'

export const SpaceCapacity = ({
	space,
	className,
	...props
}: {
	space: Pick<Space, 'capacity'>
} & ComponentProps<'div'>) => (
	<div
		data-testid='space-capacity'
		className={cn('flex flex-row items-center', className)}
		{...props}
	>
		<Users
			size={14}
			className='mr-1'
		/>

		{space.capacity}
	</div>
)
